import React, { useState, useEffect } from "react";
import { Card, Typography } from "@material-tailwind/react";
import Popup from "reactjs-popup";
import "../../../../styles/popup.css";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import API from "../../../../utils/API";
import CustomTable from "../../../DynamicComponents/CustomTable";
import { useThemeContext } from "../../../../context/ThemeContext";
import AlumniDetailsPopUp from "../PopUp/PersonalDetailsPopUp";
import { formatDateForDisplay } from "../../../../utils/Common";

const AlumniPersonalDetails = ({ setBlurActive }) => {
  const [alumniDetails, setAlumniDetails] = useState(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedAlumni, setSelectedAlumni] = useState(null);
  const user = useSelector((state) => state.auth.user) || {};
  const { user_id, department_id } = user;

  const { darkMode } = useThemeContext();

  useEffect(() => {
    if (!user_id) return;

    const fetchAlumniDetails = async () => {
      try {
        const response = await API.get(
          `/${department_id}/alumni/details?user_id=${user_id}`
        );
        const alumni = response?.data;

        if (alumni) {
          setAlumniDetails([
            {
              alumni_name: alumni.alumni_name,
              dob: formatDateForDisplay(alumni.dob),
              father_name: alumni.father_name,
              mother_name: alumni.mother_name,
              personal_contact: alumni.personal_contact,
              parent_contact: alumni.parent_contact,
              personal_email: alumni.personal_email,
              original_city: alumni.original_city,
              original_country: alumni.original_country,
            },
          ]);
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Error communicating with server"
        );
      }
    };

    fetchAlumniDetails();
  }, [user_id]);

  const openPopup = (alumni) => {
    setSelectedAlumni(alumni);
    setPopupOpen(true);
    setBlurActive(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
    setBlurActive(false);
  };

  const handleUpdateAlumniDetails = async (updatedAlumniDetails) => {
    const {
      alumni_name,
      dob,
      father_name,
      mother_name,
      personal_contact,
      parent_contact,
      personal_email,
      original_city,
      original_country,
    } = updatedAlumniDetails;

    const payload = {
      alumni_name,
      dob,
      father_name,
      mother_name,
      personal_contact,
      parent_contact,
      personal_email,
      original_city,
      original_country,
    };

    try {
      const response = await API.put(
        `/${department_id}/alumni/details?user_id=${user_id}`,
        payload
      );

      if (response && response.data) {
        toast.success("Alumni details successfully updated");

        setAlumniDetails([
          {
            alumni_name,
            dob,
            father_name,
            mother_name,
            personal_contact,
            parent_contact,
            personal_email,
            original_city,
            original_country,
          },
        ]);

        closePopup();
      } else {
        toast.error("Failed to update alumni details.");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Error communicating with server"
      );
    }
  };

  return (
    <>
      <CustomTable
        title="Personal Information"
        subtitle="Alumni's Personal Details"
        columns={[
          { key: "alumni_name", label: "Full Name" },
          { key: "dob", label: "Date of Birth" },
          { key: "father_name", label: "Father's Name" },
          { key: "mother_name", label: "Mother's Name" },
          { key: "personal_contact", label: "Personal Contact" },
          { key: "parent_contact", label: "Parent Contact" },
          { key: "personal_email", label: "Personal Email" },
          { key: "original_city", label: "City" },
          { key: "original_country", label: "Country" },
          { key: "actions", label: "Actions" },
        ]}
        data={alumniDetails}
        actions={{
          edit: (alumni) => {
            openPopup(alumni);
          },
          delete: () => {
            toast.error("Delete action is not available for personal details.");
          },
        }}
      />

      <Popup
        open={isPopupOpen}
        onClose={closePopup}
        className="mx-auto my-auto p-2"
        closeOnDocumentClick
      >
        <div>
          {selectedAlumni && (
            <AlumniDetailsPopUp
              alumni_name={selectedAlumni.alumni_name}
              dob={selectedAlumni.dob}
              father_name={selectedAlumni.father_name}
              mother_name={selectedAlumni.mother_name}
              personal_contact={selectedAlumni.personal_contact}
              parent_contact={selectedAlumni.parent_contact}
              personal_email={selectedAlumni.personal_email}
              original_city={selectedAlumni.original_city}
              original_country={selectedAlumni.original_country}
              closeModal={closePopup}
              handleUpdateAlumniDetails={handleUpdateAlumniDetails}
            />
          )}
        </div>
      </Popup>
    </>
  );
};

export default AlumniPersonalDetails;
